import React from 'react'

function FileCheckSvg() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2897_96490)">
        <path d="M13.8652 3.20312V7.20312C13.8652 7.46834 13.9696 7.7227 14.1553 7.91023C14.3411 8.09777 14.593 8.20312 14.8557 8.20312H18.8174" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.8363 21.2031H6.93202C6.40667 21.2031 5.90283 20.9924 5.53135 20.6173C5.15987 20.2423 4.95117 19.7336 4.95117 19.2031V5.20312C4.95117 4.67269 5.15987 4.16398 5.53135 3.78891C5.90283 3.41384 6.40667 3.20313 6.93202 3.20312H13.865L18.8171 8.20312V19.2031C18.8171 19.7336 18.6084 20.2423 18.2369 20.6173C17.8655 20.9924 17.3616 21.2031 16.8363 21.2031Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.91406 15.2031L10.8949 17.2031L14.8566 13.2031" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2897_96490">
          <rect width="23.7702" height="24" fill="white" transform="translate(0 0.203125)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default FileCheckSvg